/**
 * @generated SignedSource<<f051b0f3bc2a436aa842355fafd91f46>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RowWithSiblingCreate_rules$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RowMaybeWithDragAndDrop_rules">;
  readonly " $fragmentType": "RowWithSiblingCreate_rules";
};
export type RowWithSiblingCreate_rules$key = {
  readonly " $data"?: RowWithSiblingCreate_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowWithSiblingCreate_rules">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RowWithSiblingCreate_rules",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "RowMaybeWithDragAndDrop_rules"
    }
  ],
  "type": "JiraFormattingRuleConnection"
};

(node as any).hash = "bf0fac83a25d23ffe38288db84bbe828";

export default node;
